
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 1.5a3.754 3.754 0 00-3.75 3.75V7.5H4.5A1.5 1.5 0 003 9v6a1.5 1.5 0 001.5 1.5h9A1.5 1.5 0 0015 15V9a1.5 1.5 0 00-1.5-1.5h-.75V5.25A3.754 3.754 0 009 1.5z","fill":"#CACDD6"}}),_c('path',{attrs:{"d":"M6.75 5.25C6.75 4.01 7.76 3 9 3s2.25 1.01 2.25 2.25V7.5h-4.5V5.25zm3 8.042V15h-1.5v-1.708a1.494 1.494 0 01.425-2.758 1.5 1.5 0 011.623 2.213 1.49 1.49 0 01-.548.545z","fill":"#fff"}})])
          )
        }
      }
    